import React, { useContext, Fragment } from 'react'
import { useQuery } from '@apollo/client'
import { DailyMonitoringDetailsFiltersContext } from '../../../../context/DailyMonitoringDetailsFiltersContext'
import AutocompleteComponent from '../../../../components/filters/AutocompleteComponent'
import { GET_STATES } from '../../../../queries'

export default function States (): JSX.Element {
  const { filters, setFilters } = useContext(DailyMonitoringDetailsFiltersContext)
  const { loading, error, data } = useQuery(GET_STATES)

  if (loading) return <p>Loading...</p>
  if (error) return <p>Error :(</p>
  if (!data.ordersAggs.aggregations.states) return <p>No data found</p>

  const states: Array<string> = []
  data.ordersAggs.aggregations.states.buckets.map((state: any) => {
    states.push(state.key)
  })

  const onChange = (values: string[]) => {
    setFilters({
      date: filters.date,
      states: values
    })
  }

  const typographLabel = 'Estado'

  return (
    <Fragment>
      <AutocompleteComponent
        labelValue={typographLabel}
        data={states}
        defaultValues={filters.states}
        onChange={onChange}
      />
    </Fragment>
  )
}
